import React, { Component } from 'react';
export default class RGB_Input extends Component {
	constructor(props) {
		super(props);
		this.state = {
			value: this.props.value != null ? this.props.value : '#000000',
		};
	};

	shouldComponentUpdate(nextProps, nextState) {
		if (nextProps.value != nextState.value) {
			this.setState({
				value: nextProps.value,
			})
		}
		return true;
	}

	handleOnChangeRGB = (value) => {
		this.setState({
			value: value,
		});
		this.props.handleOnChangeRGB(value)
	}

	render() {
		var style = {
			padding: 20,
			display: 'flex',
			justifyContent: 'space-between',
			alignItems: 'center'
		};

		style = Object.assign(style, this.props.style);

		return (
			<div style={style}>
				<div>
					<span>{this.props.title}</span>
				</div>
				<div>
					<input style={{ width: 50, height: 50 }} type="color" value={this.state.value} onChange={(event) => this.handleOnChangeRGB(event.target.value)}>
					</input>
				</div>
			</div>
		);
	}
}
